import React from 'react'
import styled from 'styled-components'
import Link from '../../components/Link'
import ServiceCard from '../../components/ServiceCard'
import { Container as Cont, Row, media } from 'styled-bootstrap-grid'
import { rem } from '../../styles/Mixins'
import { TabList, Tabs, TabPanel, Tab } from '../../components/Tabs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import he from 'he'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'
import getImage from '../../utils/getImage'

const ServiceSection = styled.section`
  background-color: ${(props) => props.theme.colors.grey_300};
  padding: ${rem(25)} 0 ${rem(50)};

  ${media.lg`
    background-color: ${(props) => props.theme.colors.white};
  `}

  ${media.xl`
    padding: 0;
    margin: ${rem(82, 'xxxl')} 0 ${rem(145, 'xxxl')};
  `}
`

const RowStyled = styled(Row)`
  ${media.lg`
    margin-left: -30px;
    margin-right: -30px;
    justify-content: center;
  `}
`

const Container = styled(Cont)`
  ${media.xl`
    padding: 0;
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xl};
  `}

  ${media.xxl`
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xxl};
  `}

  @media (min-width: 1920px) {
    max-width: 1348px;
  }
`

const ServiceTabSection = styled(Tabs)`
  width: 100%;
`

// tab navgation styled components
const ServiceTabItemWrapper = styled(TabPanel)`
  opacity: 0;
  transition: all 0.2s ease-in-out;

  &.is-selected {
    opacity: 1;
  }
`

const SupportServicesLinkWrapper = styled.div`
  text-align: center;
  margin-top: ${rem(20)};

  ${media.xl`
    margin-top: ${rem(75, 'xxxl')};
  `}
`

// const SupportServicesLink = styled(Link)`
//   color: ${(props) => props.theme.colors.primary};
//   font-size: ${rem(15)};

//   ${media.xl`
//     font-size: ${rem(18, 'xxxl')};
//   `}
// `

const ServiceCards = (props) => {
  return (
    <ServiceSection className="services">
      <Container>
        <Row alignItems="center">
          <ServiceTabSection
            selectedTabClassName="is-selected"
            selectedTabPanelClassName="is-selected"
          >
            <TabList>
              {props?.tabs?.map((tab) => {
                return (
                  <Tab key={`tablist-${tab?.tabTitle}`}>
                    {tab?.tabTitle}
                    <span>
                      <FontAwesomeIcon icon={faAngleDown} />
                    </span>
                  </Tab>
                )
              })}
            </TabList>
            {props?.tabs?.map((tab) => {
              return (
                <ServiceTabItemWrapper key={`tabwrapper-${tab?.tabTitle}`}>
                  <RowStyled>
                    {tab?.contentCards?.map((card) => {
                      const index = tab.contentCards.indexOf(card)
                      return (
                        <React.Fragment
                          key={`cardfragment-${index}-${card?.cardTitle}`}
                        >
                          <ServiceCard
                            image={{
                              src: getImage(
                                card?.cardImage?.localFile,
                                'fluid'
                              ),
                              alt: card?.cardTitle,
                            }}
                            button={{
                              text: 'Read more',
                              link: card?.cardLink?.url,
                              target: card?.cardLink?.target,
                            }}
                            title={
                              card.cardTitle ? he.decode(card.cardTitle) : null
                            }
                            bodyText={card?.cardExcerpt}
                          />

                          {/* <Col col={12} md={12} lg={4} xl={4}>
                              <ServiceTabItem>
                                <ServiceTabItemImgWrapper>
                                  <ServiceTabItemImg
                                    src={
                                      card.cardImage.localFile
                                        .childImageSharp.fluid.src
                                    }
                                    alt={card.cardTitle}
                                  />
                                </ServiceTabItemImgWrapper>
                                <ServiceTabItemTitle>
                                  {card.cardTitle}
                                </ServiceTabItemTitle>
                                <ServiceTabItemText>
                                  {card.cardExcerpt}
                                </ServiceTabItemText>
                                <a href={card.cardLink.link}>
                                  <Button>Our purpose</Button>
                                </a>
                              </ServiceTabItem>
                            </Col> */}
                        </React.Fragment>
                      )
                    })}
                  </RowStyled>
                  {tab.hasGeneralLink ? (
                    <SupportServicesLinkWrapper>
                      <Link to={tab?.pageLink?.uri}>{tab?.linkTitle}</Link>
                    </SupportServicesLinkWrapper>
                  ) : null}
                </ServiceTabItemWrapper>
              )
            })}
          </ServiceTabSection>
        </Row>
      </Container>
    </ServiceSection>
  )
}

export default withNullErrorBoundary(ServiceCards)
